module.exports = __webpack_public_path__ + "img/avocado_no.e79e54d3.png";